import React, { useState, useContext } from "react";
import classnames from "classnames";
import Styles from "./HowItWorks.module.scss";
// import "./howitworks.scss";
import A from "@vahak/core/dist/components/app-anchor/A";
import { AppContext } from "@vahak/core/dist/app-context";

// Icons
import PlaystoreBadge from "@vahak/core/dist/icons/PlaystoreBadge.svg";
import AppImg from "components/utils/AppImg";

interface HowitworksProps {
    howitwork: any;
    sectionTitle: string;
    sectionText: string;
    tabAppNav?: string;
    tabWebNav?: string;
    onAppTabChange?: Function;
    onWebTabChange?: Function;
}

interface DataProps {
    id: number;
    title: string;
    btnURL: string;
    srcset: string;
    image: string;
    mobileApp: any;
    webApp: any;
    altText?: string;
}

const HowItWorks = ({
    howitwork,
    sectionTitle,
    sectionText,
    tabAppNav,
    tabWebNav,
    onAppTabChange,
    onWebTabChange
}: HowitworksProps) => {
    const { isMobile } = useContext(AppContext);
    const [isActivetabBox, setActivetabBox] = useState("mobileapp");
    const [isActiveMob, setActiveMob] = useState(0);
    const [isActiveWeb, setActiveWeb] = useState(0);

    const handleTabBox = (event: string) => {
        setActivetabBox(event);
    };

    const handleTabMob = (event: number) => {
        setActiveMob(event);
    };

    const handleTabWeb = (event: number) => {
        setActiveWeb(event);
    };

    return (
        <section
            className={classnames(
                Styles.main,
                "howitwork_ssection",
                isActivetabBox === "webapp" ? Styles.activeWebApp : ""
            )}
        >
            <div className={classnames(Styles.conainer, "container")}>
                <div className={Styles.heading}>
                    <h2>{sectionTitle}</h2>
                    <p>{sectionText}</p>
                </div>

                <div className={classnames(Styles.howitworkWrap)}>
                    <div className={Styles.navWrap}>
                        <ul className={Styles.nav}>
                            <li
                                className={isActivetabBox === "mobileapp" ? Styles.active : ""}
                                onClick={() => {
                                    handleTabBox("mobileapp");
                                    onAppTabChange && onAppTabChange();
                                }}
                            >
                                {tabAppNav}
                            </li>
                            <li
                                className={isActivetabBox === "webapp" ? Styles.active : ""}
                                onClick={() => {
                                    handleTabBox("webapp");
                                    onWebTabChange && onWebTabChange();
                                }}
                            >
                                {tabWebNav}
                            </li>
                        </ul>
                    </div>

                    <div className={Styles.tabBoxWrap}>
                        <div
                            className={classnames(
                                Styles.tabBox,
                                Styles.mobileAppTab,
                                isActivetabBox === "mobileapp" ? Styles.active : ""
                            )}
                        >
                            <div className={Styles.tabRow}>
                                <div className={Styles.navCol}>
                                    <ul className={Styles.tabNav}>
                                        {howitwork[0].mobileApp.map((data: DataProps) => (
                                            <li
                                                className={isActiveMob === data.id ? Styles.active : ""}
                                                onClick={() => handleTabMob(data.id)}
                                                key={data.id}
                                            >
                                                {data.title}
                                                {data.btnURL ? (
                                                    <A href={data.btnURL} className={Styles.playStoreBtn} openInNewTab>
                                                        {" "}
                                                        <PlaystoreBadge />{" "}
                                                    </A>
                                                ) : (
                                                    ""
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className={Styles.graphicsCol}>
                                    {howitwork[0].mobileApp.map((data: DataProps) => (
                                        <div
                                            className={classnames(
                                                Styles.imgBox,
                                                isActiveMob === data.id ? Styles.active : "",
                                                isActiveMob === data.id ? `imgBox_${data.id}` : ""
                                            )}
                                            key={data.id}
                                        >
                                            <AppImg
                                                src={data.image}
                                                layout="fixed"
                                                alt={data.altText}
                                                width={isMobile ? "160" : "310"}
                                                height={isMobile ? "292.44" : "565.92"}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div
                            className={classnames(
                                Styles.tabBox,
                                Styles.webAppTab,
                                isActivetabBox === "webapp" ? Styles.active : ""
                            )}
                        >
                            <div className={Styles.tabRow}>
                                <div className={Styles.navCol}>
                                    <ul className={Styles.tabNav}>
                                        {howitwork[0].webApp.map((data: DataProps) => (
                                            <li
                                                className={isActiveWeb === data.id ? Styles.active : ""}
                                                onClick={() => handleTabWeb(data.id)}
                                                key={data.id}
                                            >
                                                {data.title}
                                                {data.btnURL ? (
                                                    <A href={data.btnURL} className={Styles.webLink}>
                                                        www.vahak.in
                                                    </A>
                                                ) : (
                                                    ""
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className={Styles.graphicsCol}>
                                    {howitwork[0].webApp.map((data: DataProps) => (
                                        <div
                                            className={classnames(
                                                Styles.imgBox,
                                                isActiveWeb === data.id ? Styles.active : ""
                                            )}
                                            key={data.id}
                                        >
                                            <AppImg
                                                src={data.image}
                                                layout="responsive"
                                                alt={data.altText}
                                                width={isMobile ? "300" : "500"}
                                                height={isMobile ? "186" : "270"}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;
